/**
 * RegText component module.
 * @module shared/components/RegText
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

const _RegText = styled.span`
  &:after {
    content: '®';
  }
`;

const RegText = (props) => <_RegText>{props.children}</_RegText>;

export default RegText;

RegText.propTypes = {
  /**
   * The Copy/body of the InLineText
   */
  children: PropTypes.node,
};
